/* eslint-disable import/prefer-default-export */
import { RSAA } from 'redux-api-middleware'

import { EstateUtils } from '../utils'

export const Types = {
    COUNTRIES_FETCH_REQUEST: 'COUNTRIES_FETCH##REQUEST',
    COUNTRIES_FETCH_SUCCESS: 'COUNTRIES_FETCH##SUCCESS',
    COUNTRIES_FETCH_FAILURE: 'API_CALL##FAILURE',
}

/**
 * Fetch countries information
 * @param {string} estate estate id
 */
export const fetchCountries = () => {
    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/countries`,
                method: 'GET',
                types: [Types.COUNTRIES_FETCH_REQUEST, Types.COUNTRIES_FETCH_SUCCESS, Types.COUNTRIES_FETCH_FAILURE],
            },
        })
    }
}
